import React, { useState, useEffect } from 'react'
import { BarMenu } from '../common/BarMenu/BarMenu'
import { Header } from '../common/Header/Header'
import { Button } from 'react-bootstrap';
import initData from '../Home/initData';
import validDomain from '../../utils/validDomain';
import MapsGeolocator from '../../utils/Geolocator';
import { useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
//css
import './profile.css'
import LoginStand from './LoginStand'
import LoginUser from './LoginUser'
//api
import { TablesFetchAPI } from '../../api/Tables';
import { OrdersFetchAPI } from '../../api/Orders';
import { ClientsFetchAPI } from '../../api/Clients';
import ModalAddPoints from './Modals/ModalAddPoints';
import EditUserInfo from './EditUserInfo';
//img
import ImgUserDefault from '../img/user-default.png';
import { RenderIf } from '../common/utils/RenderIf';
import Footer from '../Home/Footer';
import SubMenuNav from '../Menu/SubMenu/SubMenuNav ';
import ModalAddressClient from './Modals/ModalAddressClient';
import ModalCreateAddressClient from './Modals/ModalCreateAddress';
import { getDireccionMasCercana } from '../../utils/AddressLocation';
import Loader from '../Home/Loader';
import HeaderMain from '../Home/Headers/HeaderMain';

import UserProfile from './UserProfile';
import Layout from '../../layout/Layout';
import { clearClientSession, normalizeClient } from '../../utils/ownershipContext';
import { useTranslation } from 'react-i18next';

export const Profile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  //const { business_code, branchoffice_code, machine_code_table } = useParams();

  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });
  const [branchoffice_code, setbranchoffice_code] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).code
    }
  });

  const [guestClient, setGuestClient] = useState(() => {
    if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
      return localStorage.getItem('guestClient')
    } else {
      return null
    }
  });


  const [machine_code, setmachine_code] = useState(() => {
    if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      return JSON.parse(localStorage.getItem("machine")).code
    } else {
      return null
    }
  });

  const [modalcreateAddressClient, setModalcreateAddressClient] = useState(false);
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [modalUser, setModalUser] = React.useState(false);
  const [modalUserUpdate, setModalUserUpdate] = useState(false);
  const [modalStand, setModalStand] = React.useState(false);
  const [addressClient, setAddressClient] = useState([])
  const [clientPointsTransactions, setClientPointsTransactions] = useState([]);
  let client = { name: "", phone: "", nickname: "" }
  let table = { name: "", client_name: "", is_room: "" }
  let token = ""
  const [modalAddPoints, setModalAddPoints] = useState(false);

  let machine = "";
  let business = "";
  let branchoffice = "";

  const hasBranchAndMachine = localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined && localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined;

  if (hasBranchAndMachine) {
    token = undefined;
    branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    machine = JSON.parse(localStorage.getItem('machine'));
    business = JSON.parse(localStorage.getItem("business"));
  }

  // Este chequeo tiene que vivir en un useEffect (con deps vacias, corre una sola vez al montar) -
  // antes estaba directo en el cuerpo del componente, asi que un navigate() se disparaba en CADA
  // render (no solo al montar), incluso antes de que el navigate anterior terminara de aplicarse.
  const BRANCH_REDIRECT_ATTEMPTS_KEY = 'branchRedirectAttempts';

  useEffect(() => {
    if (hasBranchAndMachine) {
      // Se logro establecer sucursal/maquina - reseteamos el contador para la proxima vez que
      // este usuario pierda el contexto legitimamente (no debe arrastrar intentos viejos).
      sessionStorage.removeItem(BRANCH_REDIRECT_ATTEMPTS_KEY);
      return;
    }

    if (localStorage.getItem("business") == "" || localStorage.getItem("business") == undefined) {
      // Sin negocio en localStorage, /branch/true tampoco puede resolver nada (no sabe que negocio
      // pedir) y termina rebotando de vuelta aqui - vamos a /home en su lugar para cortar el ciclo.
      navigate(`/home`)
      return;
    }

    // Freno de bucle: /branch/true deberia terminar estableciendo sucursal/maquina y mandarnos de
    // vuelta aqui. Si volvimos a /profile sin lograrlo, mandar a /branch/true otra vez solo repite
    // la misma falla (branchoffice/machine nunca llegan a guardarse alla) - esto es exactamente el
    // bucle infinito reportado entre /branch/true, /home y /profile. Despues de unos intentos,
    // dejamos de reintentar automaticamente y mandamos a elegir sucursal manualmente.
    const attempts = Number(sessionStorage.getItem(BRANCH_REDIRECT_ATTEMPTS_KEY) || 0) + 1;
    sessionStorage.setItem(BRANCH_REDIRECT_ATTEMPTS_KEY, String(attempts));

    if (attempts > 3) {
      sessionStorage.removeItem(BRANCH_REDIRECT_ATTEMPTS_KEY);
      navigate(`/branch`);
      return;
    }

    navigate(`/branch/${true}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [addressNowLocation, setAddressNowLocation] = useState(() => {
    if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
      return JSON.parse(localStorage.getItem('addressNowLocation'))
    } else {
      return null
    }
  });
  const [clientInfo, setClientInfo] = useState(0)
  const [clientLoading, setClientLoading] = useState(true)

  const [branchofficeInfo, setBranchofficeInfo] = useState(() => {
    if (localStorage.getItem('branchoffice') != null && localStorage.getItem('branchoffice') != undefined && localStorage.getItem('branchoffice') != '') {
      return JSON.parse(localStorage.getItem('branchoffice'))
    } else {
      return 0
    }
  })

  const [tableInfo, setTableInfo] = useState(() => {
    if (localStorage.getItem('table') != null && localStorage.getItem('table') != undefined && localStorage.getItem('table') != '') {
      return JSON.parse(localStorage.getItem('table'))
    } else {
      return 0
    }
  })

  if (localStorage.getItem('table') != undefined && localStorage.getItem('table') != '' && localStorage.getItem('table') != null) {
    let dataTable = JSON.parse(localStorage.getItem('table'))

    table = dataTable
  }

  const [frecuentShopperConfig, setFrecuentShopperConfig] = useState(() => {
    if (localStorage.getItem('frecuentShopperConfig') != null && localStorage.getItem('frecuentShopperConfig') != undefined && localStorage.getItem('frecuentShopperConfig') != '') {
      return JSON.parse(localStorage.getItem('frecuentShopperConfig'))
    } else {
      return null
    }
  })

  // Limpia todo el localStorage
  function clearAllLocalStorage() {
    localStorage.clear();
  }

  //================================================================================================
  const getTableById = async () => {
    let token = undefined;
    let business = JSON.parse(localStorage.getItem('business'))
    let dataTable = JSON.parse(localStorage.getItem('table'))
    try {

      const response = await TablesFetchAPI.getTableById(dataTable.id, token);
      let tableNow = response.data.table

      let codeRoom = localStorage.getItem('codeRoom')
      if (codeRoom != undefined || codeRoom != '' || codeRoom != null) {
        if (codeRoom != tableNow.password) {
          navigate(`/branch/${business_code}/${dataTable.table_code}`)
        }

      } else {
        navigate(`/branch/${business_code}/${dataTable.table_code}`)
      }
      //----------------------------------------------
    } catch (err) {
      navigate(`/branch/${business_code}/${dataTable.table_code}`)
      //console.log(err);
    }

  }

  const out = () => {
    clearAllLocalStorage()
    localStorage.removeItem('client')
    //navigate(`/home/${business_code}/${branchoffice_code}/${machine_code_table}`)
    navigate(`/home`)
  }

  const validateCurrentClient = async () => {
    const hasStoredClient = localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != ''

    if (!hasStoredClient) {
      setClientInfo(0)
      setClientLoading(false)
      return
    }

    try {
      const response = await ClientsFetchAPI.getCurrentClient(token, JSON.parse(localStorage.getItem("client")).id, { skipOwnershipErrorHandler: true });
      const verifiedClient = normalizeClient(response.data)

      if (!verifiedClient?.id) {
        clearClientSession()
        setClientInfo(0)
        setClientLoading(false)
        return
      }

      localStorage.setItem('client', JSON.stringify(verifiedClient))
      if (verifiedClient?.name === "Invitado") {
        localStorage.setItem("guestClient", JSON.stringify(verifiedClient))
        setGuestClient(verifiedClient)

      } else {
        localStorage.setItem('guestClient', 0)
        setGuestClient(0)
      }

      setClientInfo(verifiedClient)
    } catch (err) {
      clearClientSession()
      setClientInfo(0)
    } finally {
      setClientLoading(false)
    }
  }


  const [selectedTab, setSelectedTab] = useState("catogire1");

  const handleTabChange = (event) => {
    setSelectedTab(event.target.id);
    if (event.target.id === "userHistoryPoints") {
      if (clientInfo != 0) {
        getClientPointsTransactions();
      } else {
        setClientPointsTransactions([]);
      }
    }
  }

  //get address by client
  const getAddressClientNow = async () => {
    try {
      const response = await ClientsFetchAPI.getAddressClient(clientInfo?.id, token);

      setAddressClient(response.data.data)

      //console.log(coordinates);

    } catch (err) {
      setAddressClient([])
      localStorage.removeItem('addressNowLocation')
      setAddressNowLocation(null)
      //console.log("Error al obtener las direcciones del cliente: ", err);
    }
  }

  //consolidates data into corresponding statements
  const dataconsolidation = async (generalData) => {
    if (generalData == 'error') {

      navigate(`/branch/${true}`)
    }

    //console.log("data", generalData);

    let data = generalData
    //Ecommerce content
    let dataEcommerceContentUi = data.ecommerce_content.ui_config;
    let themeInit = dataEcommerceContentUi.theme

    if (localStorage.getItem("theme") == null || localStorage.getItem("theme") == undefined || localStorage.getItem("theme") == "") {
      localStorage.setItem("theme", themeInit);
    }


    if (data?.ecommerce_content?.head?.icon) {
      localStorage.setItem('iconGeneral', data.ecommerce_content?.head?.icon.url)
    }

  }

  const handlerInit = async () => {
    try {
      let response = await validDomain();
      if (response !== undefined) {

        try {
          let response = await initData()
          dataconsolidation(response)


        } catch (err) {
          //console.log(err);
        }
      } else {
        //console.log("No se pudo obtener el dominio válido");
      }
    } catch (err) {
      //console.log(err);
    }
  }

  useEffect(() => {
    if (machine_code && machine_code !== "" && machine_code !== undefined && machine !== "" && machine !== undefined && machine !== null) {
      handlerInit();
      //console.log(machine_code);
    }
  }, [machine_code]);

  useEffect(() => {
    validateCurrentClient()
  }, [])




  useEffect(() => {
    if (localStorage.getItem('codeRoom') != undefined && localStorage.getItem('codeRoom') != '' && localStorage.getItem('codeRoom') != null) {
      getTableById()
    }

    if (clientInfo != 0) {
      if (coordinates.lat !== 0 && coordinates.lng !== 0) {
        getAddressClientNow();
      }
    }

  }, [clientInfo, coordinates])

  //Function to get the transaction points of a client
  const getClientPointsTransactions = async () => {
    try {
      const token = undefined;
      const res = await ClientsFetchAPI.getFrecuentShopperPointsTransactions(undefined, token);
      setClientPointsTransactions(res.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))); // Sort by date descending
    } catch (error) {
      setClientPointsTransactions([]);
    }
  };

  // List of points transactions
  const pointsTransactionsList = () => {
    let points = clientPointsTransactions.map((transaction, index) => (
      <div key={index} className=" d-flex gap-3 py-3 border" aria-current="true">
        <div className='flex-shrink-0'>
          <i class={transaction.type === "add" ? "uil uil-check bg-primary-subtle rounded-circle py-1 text-primary px-2" : "uil uil-exchange bg-primary-subtle rounded-circle py-1 text-primary px-2"}></i>
        </div>
        <div class="d-flex gap-2 w-100 justify-content-between">
          <div>
            <h6 class="mb-0">Puntos: {transaction.points}</h6>
            <p class="mb-0 opacity-75">{transaction.type === "add" ? transaction.description : "Puntos canjeados"}</p>
          </div>
          <small className='text-muted'>{new Date(transaction.createdAt).toLocaleDateString()}</small>
        </div>
      </div>
    ));
    return (points)
  }
  const [loading, setLoading] = useState(true);
  const showLoader = loading || clientLoading;

  /* ══════════════════════════════════════════
     ICONS
  ══════════════════════════════════════════ */
  const Ico = ({ d, size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {d}
    </svg>
  );

  const IcoUser = () => <Ico d={<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>} />;
  const IcoMap = () => <Ico d={<><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" /><line x1="9" y1="3" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="21" /></>} />;
  const IcoHistory = () => <Ico d={<><polyline points="12 8 12 12 14 14" /><path d="M3.05 11a9 9 0 1 0 .5-4" /><polyline points="3 3 3 9 9 9" /></>} />;
  const IcoTag = () => <Ico d={<><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></>} />;
  const IcoLogout = () => <Ico d={<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></>} />;
  const IcoEdit = () => <Ico d={<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>} />;
  const IcoBed = () => <Ico d={<><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path d="M2 17h20" /><path d="M6 8v9" /></>} />;
  const IcoMail = () => <Ico d={<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></>} />;
  const IcoStar = () => <Ico d={<><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></>} />;
  const IcoCode = () => <Ico d={<><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></>} />;

  const NAV_ITEMS = [
    { id: "catogire1", label: t('profile.page.navInfo'), Icon: IcoUser },
    { id: "userLocation", label: t('profile.page.navAddresses'), Icon: IcoMap },
    // { id: "userHistoryPoints",label: "Puntos",        Icon: IcoHistory },
    // { id: "userCupons",       label: "Cupones",       Icon: IcoTag     },
  ];

  return (
    <>

      {showLoader && <Loader onFinish={() => setLoading(false)} />}
      {!showLoader &&
        (<>

          <Layout >
            <div className='flex-column justify-content-center'>
              {clientInfo != 0 && guestClient == 0 ?
                <>
                  <div className="up-root">


                    {/* ── Top bar ── */}
                    <div className="up-topbar">
                      <span className="up-topbar-title">{t('profile.page.myProfile')}</span>
                      <button className="up-btn-logout" onClick={() => out()}>
                        <IcoLogout /> {t('profile.page.logout')}
                      </button>
                    </div>

                    {/* ── Layout ── */}
                    <div className="up-layout">

                      {/* ════════ Sidebar ════════ */}
                      <aside className="up-sidebar">
                        <div className="up-sidebar-header">
                          <p className="up-sidebar-eyebrow">{t('profile.page.account')}</p>
                        </div>
                        <nav className="up-nav">
                          {NAV_ITEMS.map(({ id, label, Icon }) => (
                            <label
                              key={id}
                              className={`up-nav-item${selectedTab === id ? " active" : ""}`}
                              htmlFor={id}
                            >
                              {/* Radio oculto — lógica original intacta */}
                              <input
                                className="up-nav-radio"
                                name="categories"
                                type="radio"
                                id={id}
                                checked={selectedTab === id}
                                onChange={handleTabChange}
                              />
                              <span className="up-nav-icon"><Icon /></span>
                              {label}
                              <span className="up-nav-dot" />
                            </label>
                          ))}
                        </nav>
                      </aside>

                      {/* ════════ Main content ════════ */}
                      <main className="up-content">

                        {/* ══════ Tab: Información de Usuario ══════ */}
                        {selectedTab === "catogire1" && (
                          <>
                            <div className="up-section-head">
                              <h2 className="up-section-title">{t('profile.page.userInfoTitle')}</h2>
                              <p className="up-section-sub">{t('profile.page.userInfoSubtitle')}</p>
                            </div>

                            {/* ── clientInfo con datos completos ── */}
                            {clientInfo != 0 ? (
                              <div className="up-card">
                                <div className="up-card-strip" />

                                {/* Banner de mesa/habitación */}
                                {tableInfo != 0 && (
                                  <div className="up-table-banner">
                                    <div className="up-table-banner-icon"><IcoBed size={13} /></div>
                                    {table.is_room == 1 ? t('profile.page.room') : t('profile.page.table')}:
                                    <b>{table.name}</b>
                                    <span style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 4 }}>
                                      <IcoMail size={12} />
                                      {table.email}
                                    </span>
                                  </div>
                                )}

                                <div className="up-info-list">

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.page.nameLabel')}</span>
                                    <span className="up-info-value">{clientInfo.name}</span>
                                  </div>

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.shared.phoneLabel')}</span>
                                    <span className="up-info-value">{clientInfo.phone}</span>
                                  </div>

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.page.emailLabelShort')}</span>
                                    <span className="up-info-value">{clientInfo.email}</span>
                                  </div>

                                  {clientInfo.billing_name != null && clientInfo.billing_name != "" && (
                                    <div className="up-info-row">
                                      <span className="up-info-label">{t('profile.page.billingNameLabel')}</span>
                                      <span className="up-info-value">{clientInfo.billing_name}</span>
                                    </div>
                                  )}

                                  {clientInfo.ruc != null && clientInfo.dv != null && (
                                    <div className="up-info-row">
                                      <span className="up-info-label">{t('profile.shared.rucDvLabel')}</span>
                                      <span className="up-info-value">{clientInfo.ruc} / {clientInfo.dv}</span>
                                    </div>
                                  )}

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.page.codeLabel')}</span>
                                    <span className="up-info-value" style={{ fontFamily: "monospace", fontSize: "0.82rem", letterSpacing: "0.05em" }}>
                                      {clientInfo.user_code}
                                    </span>
                                  </div>

                                  <div className="up-info-row up-info-row-points">
                                    <span className="up-info-label">
                                      {frecuentShopperConfig != null ? frecuentShopperConfig.points_name : t('profile.page.myPoints')}
                                    </span>
                                    <span className="up-info-value">
                                      <IcoStar size={15} />
                                      {clientInfo.points}
                                      <span className="up-points-badge">{t('profile.page.ptsBadge')}</span>
                                    </span>
                                  </div>

                                </div>

                                {/* Footer: editar */}
                                <div className="up-card-footer">
                                  <span className="up-card-footer-note">
                                    {t('profile.page.lastUpdateNote')}
                                  </span>
                                  <button
                                    className="up-btn up-btn-ghost"
                                    onClick={() => setModalUserUpdate(true)}
                                  >
                                    <IcoEdit /> {t('profile.page.editDataBtn')}
                                  </button>
                                </div>

                                {/* Modal de edición — lógica original intacta */}
                                <EditUserInfo
                                  modalUserUpdate={modalUserUpdate}
                                  setModalUserUpdate={setModalUserUpdate}
                                  recoveryPasss={false}
                                  setParentClientInfo={setClientInfo}
                                />
                              </div>

                            ) : (
                              /* ── clientInfo en modo guest/nickname ── */
                              <div className="up-guest-card">
                                <div className="up-card-strip" />
                                <div className="up-info-list">

                                  {clientInfo.nickname && (
                                    <div className="up-info-row">
                                      <span className="up-info-label">{t('profile.page.usernameLabel')}</span>
                                      <span className="up-info-value">{clientInfo.nickname}</span>
                                    </div>
                                  )}

                                  {clientInfo.ruc != null && clientInfo.dv != null && (
                                    <div className="up-info-row">
                                      <span className="up-info-label">{t('profile.shared.rucDvLabel')}</span>
                                      <span className="up-info-value">{clientInfo.ruc} / {clientInfo.dv}</span>
                                    </div>
                                  )}

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.page.codeLabel')}</span>
                                    <span className="up-info-value" style={{ fontFamily: "monospace", fontSize: "0.82rem", letterSpacing: "0.05em" }}>
                                      {clientInfo.user_code}
                                    </span>
                                  </div>

                                  <div className="up-info-row">
                                    <span className="up-info-label">{t('profile.page.nameLabel')}</span>
                                    <span className="up-info-value">
                                      {table.client_name == null || table.client_name == undefined
                                        ? <span style={{ color: "var(--ink-3)", fontStyle: "italic" }}>{t('profile.page.noRelatedClient')}</span>
                                        : table.client_name}
                                    </span>
                                  </div>

                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* ══════ Tab: Geolocalización ══════ */}
                        {selectedTab === "userLocation" && (
                          <>
                            <div className="up-geo-head">
                              <h2 className="up-geo-title">{t('profile.page.geoTitle')}</h2>
                              <p className="up-section-sub">{t('profile.page.geoSubtitle')}</p>
                            </div>

                            <div className="up-card" style={{ padding: "1.25rem 1.5rem" }}>
                              <ModalAddressClient
                                client_id={clientInfo.id}
                                addressClient={addressClient}
                                getAddressClientNow={getAddressClientNow}
                                addressNowLocation={addressNowLocation}
                                setAddressNowLocation={setAddressNowLocation}
                                coordinates={coordinates}
                              />
                            </div>

                            <div className="up-card" style={{ overflow: "hidden", borderRadius: "var(--radius-xl)" }}>
                              <MapsGeolocator position={setCoordinates} zoom={10} />
                            </div>
                          </>
                        )}

                      </main>
                    </div>
                  </div>

                </>
                : <>

                  {/* <!--====== SIGNIN ONE PART START ======--> */}

                  <LoginUser modalUser={modalUser} setModalUser={setModalUser} />


                </>

              }
              {/* <UserProfile /> */}
            </div>
          </Layout >

        </>)
      }
      {/* <UserProfile /> */}
      {/*<LoginStand show={modalStand} onHide={() => setModalStand(false)} />*/}
      <ModalAddPoints frecuentShopperConfig={frecuentShopperConfig} setClientInfo={setClientInfo} clientInfo={clientInfo} branchoffice={branchofficeInfo} business_code={business_code} token={token} show={modalAddPoints} handleClose={() => setModalAddPoints(false)} />

    </>
  )
}
